import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Menu,
  MenuList,
  MenuItem,
  MenuDivider,
  MenuButton,
  Link,
  Box,
  Badge,
  Text,
} from '@tonic-ui/react';

const ServiceDropdownMenu = ({
  id,
  tabIndex = 0,
  menuList,
  selectedItem,
  onChange,
  menuButtonProps,
  menuListProps,
}) => {
  const { t } = useTranslation();
  const handleClick = (event, value) => {
    if (event?.key === 'Enter' || event?.type === 'click') {
      onChange(value);
    }
  };
  return (
    <>
      {selectedItem && (
        <Menu id={id} data-id={id}>
          <MenuButton
            variant="ghost"
            style={{ userSelect: 'text' }}
            data-id={`${id}-menuButton`}
            data-telemetry-id={`${id}-menuButton`}
            tabIndex={tabIndex}
            {...menuButtonProps}
          >
            {selectedItem?.label ? selectedItem.label : selectedItem}
          </MenuButton>
          <MenuList
            zIndex="2000"
            minWidth="100%"
            whiteSpace="nowrap"
            overflow="auto"
            {...menuListProps}
          >
            {menuList.map((menuItem, index) => {
              const isDivider = menuItem.label === 'showMenuDivider';
              return (
                <Fragment
                  key={isDivider ? `divider-${index}` : `${id}-menuItemBox-${menuItem.value}`}
                >
                  {isDivider ? (
                    <MenuDivider />
                  ) : (
                    <Box>
                      <Link
                        href={'/' + menuItem.value}
                        target="_self"
                        rel="noopener noreferrer"
                        style={{ wordBreak: 'break-all', color: 'inherit' }}
                        minWidth="100%"
                        textDecoration="none"
                        onClick={(e) => {
                          e.preventDefault();
                        }}
                      >
                        <MenuItem
                          key={`${id}-menuItem-${menuItem.value}`}
                          data-id={`menuItem-${menuItem.value}`}
                          data-telemetry-id={`${id}-menuItem-${menuItem.value}`}
                          disabled={menuItem.disabled}
                          onClick={(e) => handleClick(e, menuItem)}
                          onKeyDown={(e) => handleClick(e, menuItem)}
                          minWidth="100%"
                        >
                          {menuItem.isNew ? (
                            <Badge
                              badgeContent={t('new')}
                              backgroundColor="green:60"
                              borderColor="green:60"
                              color="white:primary"
                              top="8px"
                              right="-25px"
                            >
                              <Text fontSize="sm" lineHeight="1rem">
                                {menuItem.label}
                              </Text>
                            </Badge>
                          ) : (
                            <Text fontSize="sm" lineHeight="1rem">
                              {menuItem.label}
                            </Text>
                          )}
                        </MenuItem>
                      </Link>
                    </Box>
                  )}
                </Fragment>
              );
            })}
          </MenuList>
        </Menu>
      )}
    </>
  );
};

export default ServiceDropdownMenu;
